import { Routes } from '@angular/router'

import { PageNotFound } from './page-not-found/page-not-found'
import { Welcome } from './welcome/welcome'

export const routes: Routes = [
	{ path: '', redirectTo: '/welcome', pathMatch: 'full' },
	{ path: 'welcome', title: 'Welcome', component: Welcome },
	{
		path: 'interactions',
		title: 'Interactions',
		loadComponent: () => import('./interactions/interactions-list/interactions-list'),
	},
	{
		path: 'relationships',
		title: 'Relationships',
		loadComponent: () => import('./relationships/relationships-list/relationships-list'),
	},
	{ path: '**', component: PageNotFound },
]
